/**
 * Shared constants for the AI Council page + its sub-components.
 * Extracted here so PersonaPicker, LiveTranscript, CouncilResult, and
 * CouncilHistory don't each carry their own copy.
 */
import {
  Crown, DollarSign, Cpu, Workflow, Scale, ShieldAlert, Megaphone,
  Users, BarChart3, BookCheck, HeartHandshake, ShieldCheck, Radar,
  GraduationCap, Library, HeartPulse, MessagesSquare,
  Anchor, Stethoscope, Hammer, Plane, Factory, Sprout, School, Zap,
} from 'lucide-react';

export const ICON_MAP = {
  Crown, DollarSign, Cpu, Workflow, Scale, ShieldAlert, Megaphone,
  Users, BarChart3, BookCheck, HeartHandshake, ShieldCheck, Radar,
  GraduationCap, Library, HeartPulse, MessagesSquare,
  Anchor, Stethoscope, Hammer, Plane, Factory, Sprout, School, Zap,
};

export const TIER_LABEL = {
  leadership: 'Leadership',
  specialist: 'Specialists',
  industry:   'Industry Experts',
  security:   'Security',
  mentor:     'Mentors',
  concierge:  'Product Concierge',
};

export const TIER_ORDER = ['leadership', 'specialist', 'industry', 'mentor', 'security', 'concierge'];

export const COUNCIL_HARD_CAP = 25;
